import React from 'react';
import {
  ModalActionContainer,
  ModalActionContent,
  ModalActionHead,
  ModalActionBody,
  ModalActionBodyIcon,
  ModalActionBodyLabel,
  ModalActionBodyDescription,
  ModalActionFooter,
  ModalActionFooterButton,
  ModalActionFooterRadio,
} from './styles';
import { IoClose } from 'react-icons/io5';
import colors from '../../assets/styles/colors';
import RadioButtonForm from "../RadioButtonForm";

const ModalActionDocumentos = ({ title, description, open, bodyIcon, rotateIcon, setShowModal, actionFunctionUpButton, actionLabelFunctionUpButton, actionLabelFunctionDownButton, actionFunctionDownButton, backgroundIcon, radioButtonLabel, handleRadioButtonChange, radioButtonChecked, checkboxChecked, description2 }) => {
  return (
    <ModalActionContainer open={open} id="modal-action">
      <ModalActionContent>
        <ModalActionHead setShowModal={setShowModal}>
          {setShowModal && <IoClose size={26} color={colors.textSecondary} onClick={() => setShowModal(true)} id="close-icon" />}
        </ModalActionHead>
        <ModalActionBody>
          <ModalActionBodyIcon backgroundIcon={backgroundIcon} rotateIcon={rotateIcon}>
            {bodyIcon}
          </ModalActionBodyIcon>
          <ModalActionBodyLabel>
            {title}
          </ModalActionBodyLabel>
          {description && (
            <ModalActionBodyDescription>
              {description}
            </ModalActionBodyDescription>
          )}
          {description2 && (
            <ModalActionBodyDescription style={{fontWeight: 'bold'}}>
              {description2}
            </ModalActionBodyDescription>
          )}
          {radioButtonLabel && (
            <ModalActionFooterRadio style={{fontWeight: 'bold'}} id="top-action-radio">
              <RadioButtonForm 
                radios={[{ label: radioButtonLabel, value: 'Si' }]} 
                name="radioButton" 
                selected={radioButtonChecked ? 'Si' : ''} 
                setIdentificationRadioChecked={handleRadioButtonChange}
              />
            </ModalActionFooterRadio>
          )}
        </ModalActionBody>
        <ModalActionFooter>
          {actionLabelFunctionUpButton && (
            <ModalActionFooterButton style={checkboxChecked ? {background: '#002360' } : {background: '#9A9A9A' }} disabled={!checkboxChecked} onClick={() => actionFunctionUpButton()} id="top-action-button">
              {actionLabelFunctionUpButton}
            </ModalActionFooterButton>
          )}
          {actionLabelFunctionDownButton && (
            <ModalActionFooterButton onClick={() => actionFunctionDownButton()} id="bottom-action-button">
              {actionLabelFunctionDownButton}
            </ModalActionFooterButton>
          )}
        </ModalActionFooter>
      </ModalActionContent>
    </ModalActionContainer>
  )
}

export default ModalActionDocumentos
